import type { ComponentProps } from 'react';

import { cn } from '@nucleus-commerce/ui/lib/utils';

/** Ids, slugs and codes: monospace, slightly smaller, never wraps mid-token. */
export function Mono({ className, ...props }: ComponentProps<'code'>) {
  return (
    <code
      className={cn('text-muted-foreground font-mono text-[0.8125rem] break-all', className)}
      {...props}
    />
  );
}
